import React from 'react';
import styled from 'styled-components';
import { Typography, SxProps } from '@mui/material';
import { FlexColumn, Flex } from '../Flex';

export const formFieldRequiredLabel = 'This field is required';

const FieldErrorMessage = styled(Typography)`
  color: ${({ theme }) => theme.palette.common.red};
  font-size: 10px;
  line-height: 10px;
`;

const HelperText = styled(Typography)`
  color: ${({ theme }) => theme.palette.common.gray4};
`;

const Description = styled(Typography)`
  font-size: 12px;
  color: ${({ theme }) => theme.palette.common.gray2};
  line-height: 15px;
`;

const OptionalIndication = () => <HelperText>(optional)</HelperText>;

type FormFieldProps = {
  title?: string | React.ReactNode;
  description?: string | React.ReactNode;
  children: React.ReactNode;
  errorMessage?: string;
  optional?: boolean;
  sx?: SxProps;
};

const FormField = ({
  title,
  description,
  children,
  errorMessage,
  optional = false,
  sx,
}: FormFieldProps) => (
  <FlexColumn gap={1} sx={sx}>
    {title && (
      <Flex gap={1}>
        <Typography>{title}</Typography> {optional && <OptionalIndication />}
      </Flex>
    )}
    {description &&
      (typeof description === 'string' ? (
        <Description>{description}</Description>
      ) : (
        description
      ))}
    {children}
    {errorMessage && <FieldErrorMessage>{errorMessage}</FieldErrorMessage>}
  </FlexColumn>
);

export default FormField;
